import { useCallback } from 'react';
import * as Clipboard from 'expo-clipboard';
import { defineMessages, useIntl, type MessageValue } from 'react-intl';

import { openNativeShare } from '@sg/garnish';

export const useShareLineItem = () => {
  const { formatMessage } = useIntl();

  const handleShareLineItem = useCallback(
    (url: string, name: string) => {
      const message = formatMessage(messages.shareFavorite, { name });

      void openNativeShare({
        message,
        url,
        options: {
          subject: message,
        },
      });
      void Clipboard.setStringAsync(url);
    },
    [formatMessage],
  );

  return { handleShareLineItem };
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages<{ readonly shareFavorite: { readonly name: MessageValue } }>({
  shareFavorite: {
    defaultMessage: 'Checkout out the {name} at sweetgreen!',
    description: 'Order Status | Shared line item | Share button',
  },
});
